module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/video-poster-4-3bb6ed580d8c5f5aedb78c68696a5f6a.jpg";